import React from 'react'
import ExpandToggle from './expand'
type Props = {
  onClick?: () => void
  expanded?: boolean
  name: string
}
export default function SidebarTitle(props: Props): React.ReactElement<'div'> {
  return (
    <div className="Sidebar_BaseItem Sidebar_Title" onClick={props.onClick}>
      <div className="Sidebar_Label">{props.name}</div>
      <div className="Sidebar_ToRight">
        <ExpandToggle expanded={props.expanded} />
      </div>
    </div>
  )
}
